   
    
    import MatriculaService  from '@/service/v10/sigap/MatriculaService'; 
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site';   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "MatriculaShow",
        components: {   },   
    }) 
    export default class MatriculaShow extends Vue {
        
        @authStore.Getter
		public perfis!: any  

        @authStore.Getter
		public token!: any 
  
        public service = new MatriculaService();
        public model: any = null ;
        public processando = false ;
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        get hasAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
        }

        public formatCPF( cpf ): string {
            return SiteUtils.formatCPF( cpf );
        }

        created(){
            this.buscaMatricula(); 
        }

        public statusAlterado(dados){ 
            this.buscaMatricula() ;
        }

        public buscaMatricula(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));  
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public gerarHistoricoExcell() {  
            window.open( this.service.getApiUrl() + '/' + this.$route.params.id + '/boletim/excel' + '?token=' +  this.token );
		}
 
    } 
